const CONTRIBUTIONS = [
  {
    id: "tanstack-query",
    title: "TanStack/query",
    subtitle: "react-query",
    duration: "2025.02",
    image: "./react-query.png",
  },
  {
    id: "module-federation",
    title: "module-federation/core",
    subtitle: "retry-plugin",
    duration: "2024.12",
    image: "./module-federation.png",
  },
];

export default CONTRIBUTIONS;
